import type { TranscriptPayload } from '@Application/Beneficiaries/Transcripts/Actions/transcriptFetched';

export type TranscriptReviewedAction = {
	type: 'TRANSCRIPT_REVIEWED';
	payload: TranscriptPayload;
	interviewId: number;
};

export default (payload: TranscriptPayload, interviewId: number): TranscriptReviewedAction => ({
	type: 'TRANSCRIPT_REVIEWED',
	payload,
	interviewId,
});
